<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p><em>Zuat’s Philosophy</em> is a novel for general readers, especially young adults who are developing their world views. It endorses <em>laissez-faire</em> capitalism. The story may offend:</p>
<ul>
<li><p>Academic philosophers who muddy the waters of philosophy</p></li>
<li><p>Lawyers who put law above ethics</p></li>
<li><p>Executives of big companies who use ruthless tactics against small competitors</p></li>
<li><p>Environmentalists who resent even mild criticism of their precious causes</p></li>
<li><p>Young ex-schoolies who self-immerse in alcohol</p></li>
<li><p>Religious believers who don’t like:</p></li>
</ul>
<ul>
<li><p>Arguments put forward to challenge their faith</p></li>
<li><p>Exposure of yet another wearer of the cloth as a scumbag.</p></li>
</ul>
<p>A caution to Peruvians: You might not like the revival of memories of Peru of 1980s and 1990s, and the evil Shining Path.</p>
<p>Every issue is potentially political. If hens went on strike, politicians (and novelists?) of left and right might debate fiercely the price of eggs. For the rest of you, please enjoy the development of an unlikely romance. It comes with each partner clarifying his/her philosophy and taking much mental and physical risk to achieve that. By the way, Zuat is short for Anzuátegui.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?6442118b